module.exports = __webpack_public_path__ + "img/GH-kyujin-top-026.9b9cd916.webp";